// extracted by mini-css-extract-plugin
export var standaloneTable = "_g3-0";
export var standaloneTableWithBodyFill = "_g3-1";
export var withExtraHeader = "_g3-2";